"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _logger = require("./logger"); // If no USP data is set, then set it to a default value.
// https://help.quantcast.com/hc/en-us/articles/360047078534-Choice-CMP2-CCPA-API-Index-TCF-v2-0-


var setDefaultUSPData = function setDefaultUSPData() {
  if (typeof window.__uspapi === 'function') {
    window.__uspapi('uspPing', 1, function (obj, status) {
      if (status && obj.mode.includes('USP') && obj.jurisdiction.includes(obj.location.toUpperCase())) {
        window.__uspapi('setUspDftData', 1, function (_, newStatus) {
          if (!newStatus) {
            (0, _logger.logError)(new Error('[tab-cmp] Unable to set default USP string.'));
          } else {
            (0, _logger.logDebugging)('Successfully set default USP data.');
          }
        });
      } else {
        (0, _logger.logDebugging)('Not setting default USP data. User is not in the US.');
      }
    });
  }
};

var _default = setDefaultUSPData;
exports.default = _default;